<template>
  <div class="page-content" style="overflow:auto">
    <Titlebar :incrustation="'fa-lock'" :backPath="'/home'">
      <h1 v-if="target" v-text="target.title" style="font-weight:900"></h1>
    </Titlebar>
    <div class="container">
      <ModuleDescription
        v-if="target"
        :title="target.title"
        :description1="target.description1"
        :description2="target.description2"
        :description3="target.description3"
        :image4="target.image4"
        :option="target.option"
        :level="target.level"
        :is-premium-module="target.isPremiumModule"
        :is-user-premium="isPremiumUser"
        :demo-link="target.demoLink"
        :know-more-link="target.knowMoreLink"
      />
    </div>
  </div>
</template>

<script>

import Titlebar from "@/components/ui/Titlebar";
import ModuleDescription from "../components/ui/ModuleDescription";
import Auth from '@/services/auth.js';
import Utils from '@/services/utils.js';

export default {
  name: "AccessDenied",
  components: {
    ModuleDescription,
    Titlebar,
  },
  data() {
    return {
      slug: null,
      offers: null,
      informations: {
        "dashboard" : {
            title: Utils.t('module.dashboard.title'),
            isPremiumModule : false,
            level: "standard"
        },
        "kpi" : {
            title: Utils.t('navigation.kpi'),
            isPremiumModule : false,
            level: "standard"
        },
        "certificate" : {
            title: Utils.t('navigation.certificate'),
            isPremiumModule : false,
            level: "standard"
        },
        "offers" : {
            title: Utils.t('navigation.offers'),
            isPremiumModule : false,
            level: "standard"
        },
        "formation" : {
            title: Utils.t('navigation.formation'),
            isPremiumModule : false,
            level: "standard"
        },
        "reports" : {
          title: Utils.t('module.reports.title'),
          isPremiumModule : false,
          level: "standard",
        },
        "watchmen" : {
          title: Utils.t('nav.watchmen'),
          isPremiumModule : false,
          level: "standard",
        },
        "alert-history" : {
          title: Utils.t('navigation.alerts'),
          isPremiumModule : false,
          level: "standard",
        },
        "actionpoints-library" : {
          title: Utils.t('module.actionpoints-library.title'),
          description1: {
            img1:"https://pp-api.suivideflotte.net/img/buildings.png",
            p1: Utils.t('module.actionpoints-library.description1.p1'),
            p2:Utils.t('module.actionpoints-library.description1.p2'),
          },
          description2: {
            p1: Utils.t('module.actionpoints-library.description2.p1'),
            p2: Utils.t('module.actionpoints-library.description2.p2'),
          },
          description3: "https://pp-api.suivideflotte.net/img/Alerte-enrichie-fr.png",
          level: "premium",
          isPremiumModule : true,
          knowMoreLink:"https://www.beepiz.com/localisation-interieure",
          demoLink: "https://share.hsforms.com/12DlkjZCBQ5-Gm5HwsgvsiA56ack",
        },
        "actionpoints-library_no_role" : {
          title: Utils.t('module.actionpoints-library.title'),
          isPremiumModule : true,
          level: "standard"
        },
        "plans" : {
          title: Utils.t('module.plans.title'),
          description1: {
            img1:"https://pp-api.suivideflotte.net/img/buildings.png",
            p1: Utils.t('module.plans.description1.p1'),
            p2:Utils.t('module.plans.description1.p2'),
          },
          description2: {
            p1: Utils.t('module.plans.description2.p1'),
            p2: Utils.t('module.plans.description2.p2'),
          },
          description3: "https://pp-api.suivideflotte.net/img/Alerte-enrichie-fr.png",
          level: "premium",
          isPremiumModule : true,
          knowMoreLink:"https://www.beepiz.com/localisation-interieure",
          demoLink: "https://share.hsforms.com/12DlkjZCBQ5-Gm5HwsgvsiA56ack",
        },
        "devices" : {
          title: Utils.t('module.devices.title'),
          isPremiumModule : false,
          level: "standard"
        },
        "groups" : {
          title: Utils.t('module.groups.title'),
          isPremiumModule : false,
          level: "standard"
        },
        "licences" : {
          title: Utils.t('module.licences.title'),
          isPremiumModule : false,
          level: "standard"
        },
        "profiles" : {
          title: Utils.t('module.profiles.title'),
          isPremiumModule : false,
          level: "standard"
        },
        "remotemonitoring" : {
          title: Utils.t('module.remotemonitoring.title'),
          description1: {
            img1:"https://pp-api.suivideflotte.net/img/support.png",
            p1: Utils.t('module.remotemonitoring.description1.p1'),
            p2:Utils.t('module.remotemonitoring.description1.p2'),
          },
          description2: {
            p1: Utils.t('module.remotemonitoring.description2.p1'),
            p2: Utils.t('module.remotemonitoring.description2.p2'),
            p3: Utils.t('module.remotemonitoring.description2.p3')
          },
          description3: "https://pp-api.suivideflotte.net/img/Télésurveillance.png",
          option: true,
          level: "standard",
          isPremiumModule : true,
          knowMoreLink: Utils.t('module.remotemonitoring.knowMoreLink'),
          demoLink: "https://share.hsforms.com/1gUH2t4CbQXi26GU7Svl8sg56ack",
        },
        "remotemonitoring_no_role" : {
          title: Utils.t('module.remotemonitoring.title'),
          isPremiumModule : false,
          level: "standard"
        },
        "patrols" : {
          title: Utils.t('module.patrols.title'),
          description1: {
            img1:"https://pp-api.suivideflotte.net/img/logo-ronde.png",
            p1: Utils.t('module.patrols.description1.p1'),
            p2:Utils.t('module.patrols.description1.p2'),
            p3:Utils.t('module.patrols.description1.p3'),
          },
          description2: {
            p1: Utils.t('module.patrols.description2.p1'),
            p1List1: Utils.t('module.patrols.description2.p1List1'),
            p1List2: Utils.t('module.patrols.description2.p1List2'),
            p1List3: Utils.t('module.patrols.description2.p1List3'),
            p2: Utils.t('module.patrols.description2.p2'),
          },
          description3: "https://pp-api.suivideflotte.net/img/portail-ronde.png",
          level: "premium",
          isPremiumModule : true,
          knowMoreLink:"https://www.beepiz.com/rondier",
          demoLink: "https://share.hsforms.com/1khmrLhjkR82OuNhj9RIbeQ56ack",
        },
        "phonebooks" : {
          title: Utils.t('module.phonebooks.title'),
          isPremiumModule : false,
          level: "standard"
        },
        "sendNotifications": {
          title:Utils.t('nav.notifications'),
          isPremiumModule: false,
          level: "standard"
        },
        "planning" : {
          title: Utils.t('module.planning.title'),
          description1: {
            img1:"https://pp-api.suivideflotte.net/img/time-planning.png",
            p1: Utils.t('module.planning.description1.p1'),
            p2:Utils.t('module.planning.description1.p2'),
          },
          description2: {
            p1: Utils.t('module.planning.description2.p1'),
            p2: Utils.t('module.planning.description2.p2'),
            p3: Utils.t('module.planning.description2.p3'),
          },
          description3: "https://pp-api.suivideflotte.net/img/Planning rappel.png",
          image4:"https://pp-api.suivideflotte.net/img/Rappel mise en service.png",
          level: "premium",
          isPremiumModule : true,
          knowMoreLink:"https://www.youtube.com/watch?v=CNW6PQ1Rv98&t=51s",
          demoLink: "https://share.hsforms.com/1BfU5XgjdQmqr46F0KMxfEg56ack",
        },
        "planning_no_role" : {
          title: Utils.t('module.planning.title'),
          isPremiumModule : false,
          level: "standard"
        },

        "ppes" : {
          title: Utils.t('module.ppes.title'),
          description1: {
            img1:"https://pp-api.suivideflotte.net/img/casque.png",
            p1: Utils.t('module.ppes.description1.p1'),
            p2:Utils.t('module.ppes.description1.p2'),
          },
          description2: {
            p1: Utils.t('module.ppes.description2.p1'),
            p2: Utils.t('module.ppes.description2.p2'),
            p3: Utils.t('module.ppes.description2.p3'),
            p3List1:Utils.t('module.ppes.description2.p3List1'),
            p3List2:Utils.t('module.ppes.description2.p3List2'),
          },
          description3: "https://pp-api.suivideflotte.net/img/portail-epi.png",
          level: "premium",
          isPremiumModule : true,
          demoLink: "https://share.hsforms.com/1oADAfCZPRvGFnRxNYqV6Bw56ack",
        },
        "ppes_no_role" : {
          title: Utils.t('module.ppes.title'),
          isPremiumModule : true,
          level: "standard"
        },
        "tos" : {
          title: Utils.t('module.tos.title'),
          description1: {
            img1:"https://pp-api.suivideflotte.net/img/logo-tos.png",
            p1: Utils.t('module.tos.description1.p1'),
            p2:Utils.t('module.tos.description1.p2'),
          },
          description2: {
            p1: Utils.t('module.tos.description2.p1'),
            p2: Utils.t('module.tos.description2.p2'),
          },
          description3: "https://pp-api.suivideflotte.net/img/portail-tos.png",
          level: "premium",
          isPremiumModule : true,
          demoLink: "https://share.hsforms.com/13lEMvb0QQSeJfUKxFPgClA56ack",

        },
        "identifications" : {
          title: Utils.t('module.identifications.title'),
          description1: {
            img1:"https://pp-api.suivideflotte.net/img/logo-identification.png",
            p1: Utils.t('module.identifications.description1.p1'),
            p2:Utils.t('module.identifications.description1.p2'),
          },
          description2: {
            p1: Utils.t('module.identifications.description2.p1'),
            p2: Utils.t('module.identifications.description2.p2'),
          },
          description3:"https://pp-api.suivideflotte.net/img/portail-identification.png",
          level: "premium",
          isPremiumModule : true,
          knowMoreLink:"https://www.beepiz.com/application-dati-pti",
          demoLink: "https://share.hsforms.com/1ZavkklpMSKWdoI-kHP8_2w56ack"
        }
      },
      "identifications_no_role" : {
        title: Utils.t('module.identifications.title'),
        isPremiumModule : true,
        level: "standard"
      },
      "alert_no_role" : {
        title: Utils.t('navigation.alerts'),
        isPremiumModule : false,
        level: "standard"
      },
    }
  },
  mounted() {
    window.Vfc.$refs.loading.hide();
    this.slug = this.$route.params.slug
    this.offers = Auth.offers
  },
  computed: {
    isPremiumUser() {
      return Auth.offers.filter( item => item == '35' || item == '43' || item == '58').length > 0
    },
    target() {
      if (this.slug && this.informations.hasOwnProperty(this.slug)) {
        return this.informations[this.slug]
      }
      else {
        return null
      }
    }
  }
};
</script>

<style scoped></style>
